import React from 'react';
import "./Footer.css";

const Footer = () => {
  return (
    <div className='Footer'>
        {/* Footer */}

        <p>Copyright (c) UbekaAI 2026</p>
    </div>
  )
}

export default Footer